import { CampaignSocialMediaType, InfluencerCampaignDetail, InfluencerCampaignPostData } from '@anytag/graphql';
import {
  CampaignType,
  InfluencerCampaignStat,
  MarketplaceCampaignType,
  CampaignPromotionMethod,
  MarketplaceCampaignDetailType
} from '@anytag/graphql';

export interface InfluencerProfileCampaignRowData {
  currency: string;
  numberOfPosts: number;
  showCampaignInfo: boolean;
  joinedDate: string | null;
  post?: {
    id?: number | null;
    url?: string | null;
    content?: string | null;
    thumbnail?: string | null;
    socialMedia: CampaignSocialMediaType;
    mkpCampaignType?: MarketplaceCampaignType | null;
    promotionMethods: readonly CampaignPromotionMethod[];
  };
  campaign: {
    id?: number | null;
    type: CampaignType;
    title: string | null;
    thumbnail: string | null;
    hasPostTracking: boolean | null;
    mkpDetailType?: MarketplaceCampaignDetailType | null;
  };
  summary: InfluencerCampaignStat;
}

export const formatInfluencerProfileCampaignsData = (data: readonly InfluencerCampaignDetail[]) =>
  data.reduce<InfluencerProfileCampaignRowData[]>((acc, { campaignInfo, currency, summary, posts, joinedDate }) => {
    const numberOfPosts = posts.length;
    const campaign: InfluencerProfileCampaignRowData['campaign'] = {
      id: campaignInfo.id,
      type: campaignInfo.type,
      title: campaignInfo.title,
      mkpDetailType: campaignInfo.mkpDetailType,
      thumbnail: campaignInfo.thumbNail || '',
      hasPostTracking: !!campaignInfo.hasPostTracking
    };

    const newRow: InfluencerProfileCampaignRowData = {
      summary,
      currency,
      campaign,
      joinedDate,
      numberOfPosts,
      post: undefined,
      showCampaignInfo: true
    };

    if (numberOfPosts === 1) {
      const { postInfo } = posts.at(0) as InfluencerCampaignPostData;

      return [
        ...acc,
        {
          ...newRow,
          post: {
            id: postInfo.id,
            url: postInfo.postUrl,
            content: postInfo.content,
            thumbnail: postInfo.thumbNail,
            socialMedia: postInfo.socialMedia,
            mkpCampaignType: postInfo.mkpCampaignType,
            promotionMethods: postInfo.promotionMethods
          }
        }
      ];
    }

    const newRows = posts.map(({ postInfo, summary: postSummary }) => ({
      currency,
      campaign,
      numberOfPosts,
      summary: postSummary,
      joinedDate,
      showCampaignInfo: false,
      post: {
        id: postInfo.id,
        url: postInfo.postUrl,
        content: postInfo.content,
        thumbnail: postInfo.thumbNail,
        socialMedia: postInfo.socialMedia,
        mkpCampaignType: postInfo.mkpCampaignType,
        promotionMethods: postInfo.promotionMethods
      }
    }));

    return [...acc, newRow, ...newRows];
  }, []);
